import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  AddBrandApi,
  AddCategoryToBrandApi,
  AddImeiDetailsApi,
  AddProductToCategoryApi,
  baseurl,
  GetAllBrandsNameApi,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
} from "../Utility/Api";
import CreateTicket from "./CreateTicket";
import ManageRepairDevices from "./ManageRepairDevices";
import DefaultServiceModel from "./DefaultServiceModel";
import SelectServiceModal from "./SelectServicesModal";
import LoadingBoxes from "./LoadingBoxes";

const NewRepair = (props) => {
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [categories, setCategories] = useState([]);
  const [devices, setDevices] = useState([]);
  const [devicesByCategory, setDevicesByCategory] = useState({});
  const [searchBrand, setSearchBrand] = useState("");
  const [modelSearch, setModelSearch] = useState("");
  const [brandsData, setBrandsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddModelModal2, setShowAddModelModal2] = useState(false);
  const [selectedBrandName, setSelectedBrandName] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedModelName, setSelectedModelName] = useState("");
  const [selectedCategoryId, setSeelctedCategoryId] = useState();
  const [SelectedModelId, setSelectedModelId] = useState();
  const [showAddModelModal21, setShowAddModelModal21] = useState(false);
  const [step1, setStep1] = useState(1);

  const handleNext = () => {
    setStep1(2); // Show SelectDeviceModal content
  };

  const handleBack = () => {
    setStep1(1); // Go back to CreateTicket
  };

  const handleCloseAll = () => {
    // props?.onpress(); // Close parent modal
    setStep1(1); // Reset step
  };

  useEffect(() => {
    console.log("create props", props);
    GetAllBransName();
    GetAllBrandsCategoryandDevices();
    // GetAllBrandsById();
    // GetAllBrandsCategory()
    // GetAllDeviceCategoryById()
  }, []);

  const GetAllBransName = () => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(GetAllBrandsNameApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //  console.log(result);
        if (result?.brands) {
          setBrands(result?.brands);
          setSelectedBrand(result.brands[0]?.brandId);
          //GetAllBrandsCategory(result.brands[0]?.brandId);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetAllBrandsById = () => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getBrandById/13`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log("brands category", result);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const GetAllBrandsCategory = (brandId) => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getCategoriesByBrandId/${brandId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log("category", result);
        setCategories(result?.brand?.categories || []);
        // setCategories(result?.categories || []);
        // setDevicesByCategory({});
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  };

  const GetAllDeviceCategoryById = (brandId, categoryId) => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${baseurl}getDevicesByCategoryId/${brandId}/${categoryId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log("category device list", result);
        setDevices(result?.devices || []);
        setDevicesByCategory((prev) => ({
          ...prev,
          [categoryId]: result?.devices || [],
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetAllBrandsCategoryandDevices = () => {
    setLoading(true);
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getDefaultBrands`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("categoryand devices", result);
        setLoading(false);

        setBrandsData(result?.data || []);
        //setCategories(result?.brand?.categories || []);
        // setCategories(result?.categories || []);
        // setDevicesByCategory({});
      })
      .catch((error) => {
        setLoading(false);

        console.error("Error fetching categories:", error);
      });
  };

  useEffect(() => {
    if (brandsData.length > 0) {
      if (!selectedBrand) {
        setSelectedBrand(brandsData[0].id);
      }

      if (searchBrand) {
        const matchingBrand = brandsData.find((b) =>
          b.name.toLowerCase().includes(searchBrand.toLowerCase())
        );
        if (matchingBrand) {
          setSelectedBrand(matchingBrand.id);
        }
      }
    }
  }, [brandsData, searchBrand]);

  // useEffect(() => {
  //   if (brandsData.length > 0) {
  //     // Set default brand if nothing is selected yet
  //     if (!selectedBrand) {
  //       setSelectedBrand(brandsData[0].brandId);
  //     }

  //     // If searchBrand is typed, find matching brand and set it
  //     if (searchBrand) {
  //       const matchingBrand = brandsData.find((b) =>
  //         b.brandName.toLowerCase().includes(searchBrand.toLowerCase())
  //       );
  //       if (matchingBrand) {
  //         setSelectedBrand(matchingBrand.brandId);
  //       }
  //     }
  //   }
  // }, [brandsData, searchBrand]);

  // useEffect(() => {
  //   const matchingBrand = brandsData.find((b) =>
  //     b.brandName.toLowerCase().includes(searchBrand.toLowerCase())
  //   );
  //   if (searchBrand && matchingBrand) {
  //     setSelectedBrand(matchingBrand.brandId);
  //   }
  // }, [searchBrand, brandsData]);
  const [manageShowmodal, setManageShowmodal] = useState(false);
  const onPress = () => {
    setManageShowmodal(false);
  };
  const OnPress = () => {
    setShowAddModelModal2(false);
  };

   const [activeCategoryId, setActiveCategoryId] = useState(null);
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

   // Handle window resize to detect mobile view
   useEffect(() => {
     const handleResize = () => {
       setIsMobile(window.innerWidth <= 767);
     };
     window.addEventListener("resize", handleResize);
     return () => window.removeEventListener("resize", handleResize);
   }, []);

   // Handle click on model_column div
   const handleCategoryClick = (categoryId) => {
     if (isMobile) {
       setActiveCategoryId(categoryId);
     }
   };

  return (
    <>
      {loading ? (
        <>
          <div className="loading-box">
            <LoadingBoxes />
          </div>
        </>
      ) : // <div className="landing_loader">
      //   <div className="innerloader">
      //     <img src="img/spin-1s-156px.gif" alt="" />
      //   </div>
      // </div>
      null}
      {step1 === 1 ? (
        <>
          <div
            className="modal-dialog modal-dialog-centered cusmodal_xl"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="selectdeviceModalLabel">
                  Select Device
                </h5>
                <button
                  type="button"
                  style={{ marginLeft: "10px" }}
                  className="close"
                  // data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    document
                      .querySelectorAll(".modal-backdrop")
                      .forEach((el) => el.classList.remove("modal-backdrop"));
                    props?.onPress();
                    props?.onClose();
                  }}
                >
                  <span className="close_icon" />
                </button>
                <button
                  className="manage_service_btn"
                  type="button"
                  data-toggle="modal"
                  data-target="#menuitemsModal"
                  onClick={() => {
                    setManageShowmodal(true);
                    setStep1(3);
                  }}
                >
                  <img src="assets/img/repair-edit-service-icon.png" alt="" />
                  Manage Repairs &amp; Services
                </button>

                <p>Select customer device brand and model</p>
              </div>
              <div className="modal-body">
                <div className="custom_form manage_service_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="cus_device_search">
                          <div className="search_field">
                            <input
                              type="text"
                              className="form-control"
                              name="brandsearch"
                              placeholder="Search Brand"
                              value={searchBrand}
                              onChange={(e) => setSearchBrand(e.target.value)}
                            />
                            <div className="search_icon">
                              <img
                                src="assets/img/repair-deivce-search-icon.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="cus_device_list">
                          {brandsData
                            .filter((brand) =>
                              brand.name
                                .toLowerCase()
                                .includes(searchBrand.toLowerCase())
                            )
                            .map((brand) => (
                              <button
                                key={brand.id}
                                type="button"
                                className={
                                  selectedBrand === brand.id ? "active" : ""
                                }
                                onClick={() => setSelectedBrand(brand.id)}
                              >
                                {brand.name}
                              </button>
                            ))}
                        </div>

                        <div className="cus_device_search">
                          <div className="search_field">
                            <input
                              type="text"
                              className="form-control"
                              name="modelsearch"
                              placeholder="Search Model"
                              value={modelSearch}
                              onChange={(e) => setModelSearch(e.target.value)}
                            />
                            <div className="search_icon">
                              <img
                                src="assets/img/repair-deivce-search-icon.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="cus_device_model_list">
                          {brandsData
                            .find((b) => b.id === selectedBrand)
                            ?.subproducts?.map((category) => {
                              const filteredDevices = category.devices?.filter(
                                (device) =>
                                  device.deviceName
                                    .toLowerCase()
                                    .includes(modelSearch.toLowerCase())
                              );

                              if (!filteredDevices.length) return null;

                              return (
                                <div
                                  className={`model_column ${
                                    isMobile &&
                                    activeCategoryId === category.categoryId
                                      ? "active"
                                      : ""
                                  }`}
                                  key={category.categoryId}
                                  onClick={() =>
                                    handleCategoryClick(category.categoryId)
                                  }
                                >
                                  <div className="prod_category">
                                    <span>{category.categoryName}</span>
                                  </div>
                                  <div className="prod_list">
                                    <ul>
                                      {filteredDevices.map((device) => (
                                        <li
                                          key={device.deviceId}
                                          onClick={() => {
                                            setSelectedCategoryName(
                                              category.categoryName
                                            );
                                            setSelectedBrandName(
                                              brandsData.find(
                                                (b) => b.id === selectedBrand
                                              )?.name || ""
                                            );
                                            setSeelctedCategoryId(
                                              category.categoryId
                                            );
                                            setSelectedModelName(
                                              device.deviceName
                                            );
                                            setSelectedModelId(device.deviceId);
                                          }}
                                          className={
                                            device.deviceId === SelectedModelId
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          {device.deviceName}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary cancel_btn mr-auto"
                    // data-dismiss="modal"
                    onClick={() => {
                      props?.onPress();

                      props?.onBack();
                    }}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary skip_btn"
                    onClick={(e) => {
                      e.preventDefault(); // prevent default navigation
                      setShowAddModelModal2(true);
                      // Clear the selection
                      setSelectedBrandName("");
                      setSelectedCategoryName("");
                      setSeelctedCategoryId("");
                      setSelectedModelName("");
                      setSelectedModelId(null);
                      handleNext();
                    }}
                  >
                    Skip
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary success_btn"
                    onClick={(e) => {
                      handleNext();
                      e.preventDefault(); // prevent default navigation
                      setShowAddModelModal2(true);
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {showAddModelModal2 && (
            <div
              className="modal  show d-block common_modal selectservice_modal cus_repair_modal"
              id="selectserviceModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="selectserviceModalLabel"
              aria-hidden="true"
              // className="modal show d-block common_modal editrepairproduct_modal cus_repair_modal"
              // id="editrepairproductModal"
              // tabIndex={-1}
              // role="dialog"
              // aria-labelledby="editrepairproductModalLabel"
              // aria-hidden="true"
            >
              {/* <DefaultServiceModel
            product={selectedModelName}
            Brand={selectedBrandName}
            series={selectedCategoryName}
            onpress={OnPress}
            prop={props}
            brandid={selectedBrand}
            productid={SelectedModelId}
            seriesid={selectedCategoryId}
          /> */}
              <SelectServiceModal
                product={selectedModelName}
                Brand={selectedBrandName}
                series={selectedCategoryName}
                onpress={OnPress}
                prop={props}
                brandid={selectedBrand}
                productid={SelectedModelId}
                seriesid={selectedCategoryId}
                onBack1={handleBack}
                onClose1={handleCloseAll}
                onNext={handleNext}
              />
            </div>
          )}
        </>
      )}
      {manageShowmodal && step1 == 3 && (
        <div
          className="modal common_modal menuitems_modal cus_repair_modal"
          id="menuitemsModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="menuitemsModalLabel"
          aria-hidden="true"
        >
          {" "}
          <ManageRepairDevices
            props={onPress}
            prop={props}
            onBack1={handleBack}
            onClose1={handleCloseAll}
            onNext={handleNext}
          />
        </div>
      )}
    </>
  );
};

export default NewRepair;
